





























































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import axios, { AxiosResponse } from 'axios';
import moment, { Moment } from 'moment';
import { dateTime } from '@/util/adapter';
import SingleImageUpload from '@/component/single-image-upload.vue';
import MultipleImageUpload from '@/component/multiple-image-upload.vue';
import ActivityConfigSecondWare from './config-second-ware.vue';
import storage from 'baimahu/storage';
import {
  Ware,
  ConfigWareData,
  WareSortType,
  getWare,
  ActivityType,
} from './config';
const { VUE_APP_FCREST: FCREST, VUE_APP_FCAPI: FCAPI } = process.env;
const UPLOAD_DIR = {
  // home_img: 'home',
  slide: 'slide',
  detail: 'detail',
  wx_group: 'wx_group',
  wechat: 'wechat',
};
const SLIDE_MAX_LENGTH: number = 5;
const GUIDE_TEXT_MAX_LENGTH: number = 36;
const WX_MODAL_MAX_LENGTH: number = 8;
const _ = {
  keyBy: require('lodash/keyBy'),
  each: require('lodash/forEach'),
  map: require('lodash/map'),
};
const API = {
  activity: `${FCAPI}/shang/promotion/activity`,
  verification_id: `${FCREST}/promotion/shang/activity/room/`,
  ware_data: `${FCAPI}/shang/promotion/activity/ware`,
};

interface Activity {
  apply_number: string;
  apply_multiple: string;
  appid: string;
  broadcast_room: string;
  detail_img: string[];
  // home_img: string;
  live_start_time: any;
  live_end_time: any;
  live_send_time: any;
  live_room_id: string;
  personage_title: string;
  personage_qr_code: string;
  personage_wx_number: string;
  slideshow: string[];
  share_description: string;
  subscribe_number: string;
  subscribe_multiple: string;
  show_qr_code: number;
  skip_type: number;
  wx_qr_code: string;
  show_wx_welfare: number;
  qr_code_title: number;
}
interface Validator {
  field: string;
  validate: (value: any, avtivity: Activity) => boolean;
  message: string;
  status: 'success' | 'error';
  help: string;
}

function getActivityData(remote?: any) {
  remote = remote || {};
  return {
    appid: remote.appid || '',
    apply_number: remote.apply_number || '',
    apply_multiple: remote.apply_multiple || '',
    broadcast_room: remote.broadcast_room || '',
    detail_img: remote.detail_img ? remote.detail_img.split(',') : [],
    // home_img: remote.home_img || '',
    live_start_time: remote.live_start_time
      ? moment(remote.live_start_time * 1000)
      : undefined,
    live_end_time: remote.live_end_time
      ? moment(remote.live_end_time * 1000)
      : undefined,
    live_send_time: remote.live_send_time
      ? moment(remote.live_send_time * 1000)
      : undefined,
    live_room_id: remote.live_room_id || '',
    personage_title: remote.personage_title || '',
    personage_qr_code: remote.personage_qr_code || '',
    personage_wx_number: remote.personage_wx_number || '',
    share_description: remote.share_description || '',
    subscribe_number: remote.subscribe_number || '',
    subscribe_multiple: remote.subscribe_multiple || '',
    show_qr_code: remote.show_qr_code || undefined,
    slideshow: remote.slideshow ? remote.slideshow.split(',') : [],
    skip_type: remote.skip_type || 1,
    wx_qr_code: remote.wx_qr_code || '',
    qr_code_title: remote.qr_code_title || '扫码进群',
    show_wx_welfare: remote.show_wx_welfare || 1,
  };
}

function getValidatorMap(
  is_activity_type_live: boolean,
  is_skip_type: number,
  is_show_wx_module: boolean,
): { [field: string]: Validator } {
  // 直播模块表单
  const arr = is_activity_type_live
    ? is_skip_type === 2
      ? [
          {
            field: 'live_start_time',
            validate: (value: string): boolean => !!value,
            message: '请选择直播开始时间',
          },
          {
            field: 'live_end_time',
            validate: (value: string): boolean => !!value,
            message: '请选择直播结束时间',
          },
          {
            field: 'broadcast_room',
            validate: (value: string): boolean => !!value,
            message: '请输入直播间小程序路径',
          },
          {
            field: 'live_send_time',
            validate: (value: string): boolean => !!value,
            message: '请选择直播推送时间',
          },
        ]
      : [
          {
            field: 'live_room_id',
            validate: (value: string): boolean => !!value,
            message: '请输入直播间id',
          },
        ]
    : [];
  const wx_module_form =
    +is_show_wx_module === 1
      ? [
          {
            field: 'qr_code_title',
            validate: (value: string): boolean => !!value,
            message: '请输入弹窗标题',
          },
          {
            field: 'wx_qr_code',
            validate: (value: string): boolean => !!value,
            message: '请上传微信二维码',
          },
        ]
      : [];
  const list: any[] = [
    // {
    //   field: 'home_img',
    //   validate: (value: string): boolean => !!value,
    //   message: '请上传首页图',
    // },
    {
      field: 'slideshow',
      validate: (list: string[]): boolean =>
        list.length > 0 && list.length <= SLIDE_MAX_LENGTH,
      message: '请上传轮播图',
    },
    {
      field: 'detail_img',
      validate: (list: string[]): boolean => list.length > 0,
      message: '请上传详情图',
    },
    ...arr,
    ...wx_module_form,
  ].map((item): Validator => ({ ...item, status: 'success', help: '' }));
  return _.keyBy(list, (item: Validator) => item.field);
}

@Component({
  components: {
    MultipleImageUpload,
    SingleImageUpload,
    ActivityConfigSecondWare,
  },
})
export default class ConfigPage extends Vue {
  activity: any = getActivityData();
  activity_id: any = '';
  formItemLayout: any = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  };
  field_watch_list: (() => void)[] = [];
  is_live_mode: any = '';
  is_loading: boolean = false;
  last_live_room_id: number | string = '';
  previewVisible: boolean = false;
  previewImage: any = '';
  send_data: any = {};
  space_item_layout: any = {
    labelCol: { span: 3, offset: 3 },
    wrapperCol: { span: 15 },
  };
  margin_left_layout: any = {
    labelCol: { span: 3, offset: 3 },
    wrapperCol: { span: 15 },
  };
  validatorMap: { [field: string]: Validator } = {};
  ware_data: ConfigWareData = {
    main_title: '',
    subtitle: '',
    sort_type: WareSortType.vertical,
    show_ware_count_in_vertical: '3',
    ware_list: [],
  };
  is_show_ware: boolean = false;
  GUIDE_TEXT_MAX_LENGTH: number = GUIDE_TEXT_MAX_LENGTH;
  SLIDE_MAX_LENGTH: number = SLIDE_MAX_LENGTH;
  UPLOAD_DIR: any = UPLOAD_DIR;
  get wxModalTitleMaxLength() {
    return WX_MODAL_MAX_LENGTH;
  }
  get activity_type(): ActivityType {
    return +this.$route.query.activity_type;
  }

  get activity_type_enum(): object {
    return ActivityType;
  }

  @Watch('activity.personage_title')
  onGuideTextChange(val: string, old_val: string) {
    if (val.length > GUIDE_TEXT_MAX_LENGTH) {
      this.activity.personage_title = old_val;
    }
  }
  @Watch('activity_type')
  @Watch('activity.skip_type')
  @Watch('activity.show_wx_welfare')
  validatorMapChange() {
    this.validatorMap = getValidatorMap(
      this.activity_type === ActivityType.live,
      this.activity.skip_type,
      this.activity.show_wx_welfare,
    );
  }
  @Watch('activity.live_room_id')
  liveRoomIdIsChange() {
    this.validate('live_room_id');
  }
  validateCommit() {
    const form = this.activity as any;
    let is_valid: boolean = true;
    _.each(this.validatorMap, (validator: Validator, field: string) => {
      if (!this.validate(field)) {
        is_valid = false;
      }
    });
    if (!is_valid) {
      this.$message.error('请填入必填项');
      return false;
    }
    if (
      this.is_show_ware &&
      this.ware_data.sort_type === WareSortType.vertical &&
      !this.ware_data.show_ware_count_in_vertical
    ) {
      this.$message.error('请填写商品在一行一个的排列方式下显示多少个');
      return false;
    }
    return is_valid;
  }
  validate(field: string) {
    const form = this.activity as any;
    const is_valid = this.validatorMap[field]
      ? this.validatorMap[field].validate(form[field], form)
      : '';
    if (this.validatorMap[field]) {
      this.validatorMap[field].status = is_valid ? 'success' : 'error';
      this.validatorMap[field].help = is_valid
        ? ''
        : this.validatorMap[field].message;
      return is_valid;
    }
  }

  commonBeforeUpload(file: any) {
    if (file.size / 1024 / 1024 > 2) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
  }

  beforeSlideUpload(file: any, fileList: any[]) {
    if (file.size / 1024 / 1024 > 2) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
    if (this.activity.slideshow.length + fileList.length > SLIDE_MAX_LENGTH) {
      this.$message.error(`最多上传 ${SLIDE_MAX_LENGTH} 张`);
      return false;
    }
  }

  handlePreview(imageUrl: string) {
    this.previewImage = imageUrl;
    this.previewVisible = true;
  }

  handlePreviewCancel() {
    this.previewVisible = false;
  }

  onWareChange() {
    this.is_show_ware = !this.is_show_ware;
  }

  // 时间moment格式转为10位时间戳
  timeStamp(time: Moment) {
    const time_stamp: any = time ? time.valueOf() : 0;
    const midway_time_stamp: string = JSON.stringify(time_stamp / 1000);
    const deal_time_stamp = parseInt(midway_time_stamp, 10);
    return deal_time_stamp;
  }

  // 获取对应活动的信息
  async getActivityInfo(id: any) {
    this.is_loading = true;
    const res = await this.$axios.get(`${API.activity}/${id}`);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      this.is_loading = false;
      return;
    }
    const remote = res.data.data;
    /* 商品数据 */
    const _ware_res = await this.$axios.get(
      `${API.ware_data}?activity_id=${id}`,
    );
    const _ware_api_data = _ware_res.data;
    if (_ware_api_data.status !== 200) {
      this.$message.error(_ware_api_data.message);
      return;
    }
    const _remote_ware_list = _ware_api_data.data;
    this.activity = getActivityData(remote);
    this.last_live_room_id = this.activity.live_room_id;
    this.ware_data = {
      main_title: remote.ware_main_title || '',
      subtitle: remote.ware_subtitle || '',
      sort_type: remote.order_type || WareSortType.vertical,
      show_ware_count_in_vertical: remote.ware_show_number || '',
      ware_list: (_remote_ware_list || []).map((item: any, index: number) =>
        getWare(item.ware, index + 1),
      ),
    };
    this.is_show_ware = remote.ware_relevance === 1;
    /* 商品数据 end */
    this.is_loading = false;
  }

  getSendData() {
    const send_data: any = storage.getItem('activity:send:first') || {};
    send_data.home_img = this.activity.slideshow[0] || '';
    send_data.slideshow = this.activity.slideshow.toString() || '';
    send_data.detail_img = this.activity.detail_img.toString();
    send_data.share_description = this.activity.share_description || '';
    send_data.subscribe_number = this.activity.subscribe_number || '';
    send_data.subscribe_multiple = this.activity.subscribe_multiple || '';
    send_data.apply_number = this.activity.apply_number || '';
    send_data.apply_multiple = this.activity.apply_multiple || '';
    send_data.live_start_time =
      this.timeStamp(this.activity.live_start_time) || 0;
    send_data.live_end_time = this.timeStamp(this.activity.live_end_time) || 0;
    send_data.broadcast_room = this.activity.broadcast_room || '';
    send_data.live_send_time =
      this.timeStamp(this.activity.live_send_time) || 0;
    send_data.show_qr_code = this.activity.show_qr_code
      ? this.activity.show_qr_code
      : 2;
    send_data.wx_qr_code = this.activity.wx_qr_code || '';
    send_data.personage_title = this.activity.personage_title || '';
    send_data.personage_qr_code = this.activity.personage_qr_code || '';
    send_data.personage_wx_number = this.activity.personage_wx_number || '';
    send_data.live_room_id = this.activity.live_room_id * 1 || '';
    send_data.appid = this.activity.appid || '';
    send_data.skip_type = this.activity.skip_type || 2;
    /* 商品数据 */
    send_data.ware_relevance = this.is_show_ware ? 1 : 2;
    send_data.ware_main_title = this.ware_data.main_title;
    send_data.ware_subtitle = this.ware_data.subtitle;
    send_data.order_type = this.ware_data.sort_type;
    send_data.ware_show_number = this.ware_data.show_ware_count_in_vertical;
    send_data.ware_id_list = this.ware_data.ware_list.map(
      (item: Ware) => item.id,
    );
    send_data.qr_code_title = this.activity.qr_code_title;
    send_data.show_wx_welfare = this.activity.show_wx_welfare;
    /* 商品数据 end */
    this.send_data = send_data;
    storage.setItem('activity:send:second', send_data);
  }

  // 点击下一步
  async goShareRewardConfig() {
    const skip_type = this.activity.skip_type === 1; // 直播活动类型；
    const live_room_id_is_change =
      this.last_live_room_id === this.activity.live_room_id; // 直播间id是否和之前是相同的；
    const profile = storage.getItem('profile') || {};
    const merchant_id = profile.merchant_id || '';
    if (this.$route.query.activity_id) {
      if (skip_type && !live_room_id_is_change) {
        const verification_result = await this.$axios.get(
          `${API.verification_id}${this.activity.live_room_id}?merchant_id=${merchant_id}`,
        );
        if (verification_result.data.data) {
          this.$message.error('直播房间id已被使用，请更换');
          return;
        }
      }
    } else {
      if (this.activity.skip_type === 1) {
        const verification_result = await this.$axios.get(
          `${API.verification_id}${this.activity.live_room_id}?merchant_id=${merchant_id}`,
        );
        if (verification_result.data.data) {
          this.$message.error('直播房间id已被使用，请更换');
          return;
        }
      }
    }

    if (!this.validateCommit()) {
      return;
    }
    if (this.activity_type === ActivityType.live) {
      if (this.activity.skip_type === 2) {
        if (
          !(
            this.activity.live_start_time &&
            this.activity.live_end_time &&
            this.timeStamp(this.activity.live_start_time) <
              this.timeStamp(this.activity.live_end_time)
          )
        ) {
          this.$message.error('开始时间不能晚于结束时间');
          return;
        }
      }
    }
    await this.getSendData();
    // 判断是新增活动步骤还是编辑活动步骤
    if (this.$route.query.activity_id) {
      // 编辑活动
      this.$router.push({
        path: '/activity/config-third',
        query: {
          activity_id: this.activity_id,
          send_data: this.send_data,
        },
      });
    } else {
      // 新增活动
      this.$router.push({
        path: '/activity/config-third',
        query: {
          send_data: this.send_data,
        },
      });
    }
  }

  async created() {
    this.validatorMap = getValidatorMap(
      this.activity_type === ActivityType.live,
      this.activity.skip_type,
      this.activity.show_wx_welfare,
    );
    if (this.$route.query.activity_id) {
      this.activity_id = this.$route.query.activity_id;
      await this.getActivityInfo(this.activity_id);
    }

    this.field_watch_list = _.map(
      this.validatorMap,
      (validator: Validator, field: string) =>
        this.$watch(`activity.${field}`, (val: any) => {
          this.validate(field);
        }),
    );
  }

  beforeDestroy() {
    this.field_watch_list.forEach((unwatch: () => void) => unwatch());
  }
}
